function appointmentServiceFilter(appointmentService, clientId, clientType) {
    return (
        appointmentService.stateEnum !== Meevo.Model.StateEnum.Delete &&
        appointmentService.transitionState !== Meevo.Model.AppointStateEnum.Pending &&
        (
            (clientId == undefined && clientType == undefined && !appointmentService.client) ||
            (appointmentService.client && (
                (clientId && appointmentService.client.id === clientId) ||
                (clientType && appointmentService.client.clientType === clientType) )
            )
        )
    );
}

angular.module('ApptBookApp').filter('appointmentServicesByClientId', [
    () => (appointmentServices, clientId, clientType) => {
        if (!appointmentServices) {
            return [];
        }

        let filtered = appointmentServices.filter((appointmentService) => appointmentServiceFilter(appointmentService, clientId, clientType));

        return filtered;
    }
]);

angular.module('ApptBookApp').filter('appointmentServicesDeleteReason', [
    () => (appointmentServices, clientId, clientType) => {
        if (!appointmentServices) {
            return [];
        }

        let filtered = appointmentServices.filter((appointmentService) => !appointmentService.isNew && appointmentService.stateEnum !== Meevo.Model.StateEnum.Delete &&
            appointmentService.transitionState !== Meevo.Model.AppointStateEnum.Pending);

        return filtered;
    }
]);

angular.module('ApptBookApp').filter('durationFormat', [
    () => (duration) => {
        if (duration == null) {
            return '';
        }

        if (duration === 0) {
            return '0m';
        }

        const hours = Math.floor(duration / 60);
        const minutes = duration % 60
        const time = (hours > 0 ? `${hours}h ` : '') + (minutes > 0 ? `${minutes}m` : '');
        return time;
    }
]);